import { useLayoutEffect, useState } from 'react';
import { isSsr } from '../utils';
export function useIsClientSide() {
  const [isClient, setIsClient] = useState(false);
  useLayoutEffect(() => {
    if (!isSsr()) {
      setIsClient(true);
    }
  }, []);
  return isClient;
}